module.exports = __webpack_public_path__ + "static/Face-Sarah.dadeef3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Face-Sarah.jpg
// module id = 490
// module chunks = 144251824217401